interface DefaultOpengraphImageProps {
  title: string;
  image: string;
  logoImage: string;
  description: string | null;
}

export function DefaultOpengraphImage({
  title,
  image,
  logoImage,
  description,
}: DefaultOpengraphImageProps) {
  return (
    <div
      style={{
        background: `#EDF6FD`,
        position: `relative`,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        color: 'black',
        paddingLeft: '50px',
        paddingRight: '80px',
        paddingTop: '50px',
        paddingBottom: '50px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '608px',
          }}
        >
          <h1
            style={{
              fontSize: '70px',
              lineHeight: '90%',
              fontWeight: 'bold',
              letterSpacing: '-1px',
              fontFamily: `"MullerBold"`,
            }}
          >
            {title}
          </h1>
          {description && (
            <p
              style={{
                fontSize: '30px',
                lineHeight: '120%',
                marginTop: '20px',
                fontFamily: `"MullerRegular"`,
              }}
            >
              {description}
            </p>
          )}
        </div>
        {image && (
          <img
            alt='Immigrant Invest'
            width={300}
            style={{
              width: '485px',
              height: '630px',
              marginLeft: '50px',
              objectFit: 'contain',
            }}
            src={image}
          />
        )}
      </div>
      <img
        alt='Immigrant Invest'
        width={195}
        height={34}
        style={{
          width: '195px',
          height: '34px',
          objectFit: 'contain',
          objectPosition: 'top',
          position: 'absolute',
          bottom: '50px',
          left: '50px',
        }}
        src={logoImage}
      />
    </div>
  );
}
